import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import { ReactComponent as CloseIcon } from '../assets/icons/Close-Icon.svg'

import styles from './SidebarModal.module.scss'
import { ButtonBase } from '@material-ui/core'
import { isE700Device } from '../VNAndroidSDK/Utils'

const SidebarModal = ({
  show,
  isShowClear,
  isRevenueSetUp,
  clearCart,
  title,
  subTitle,
  leftAccessory,
  onClose,
  children,
  className,
  contentStyle,
  displayOverlay = true,
}) => {
  const classNames = cn(styles.sidebarModal, className)
  let subTitleElement = null
  const mediaQueryMobile = window?.matchMedia('(max-width: 500px)')
  const centerTitle = mediaQueryMobile?.matches && leftAccessory
  const showCloseIcon = isRevenueSetUp ? false : true
  const overlayColor = { backgroundColor: !showCloseIcon ? 'black' : undefined }

  if (!show) return null

  if (!isEmpty(subTitle)) {
    subTitleElement = <div className={styles.headerRow}>{subTitle}</div>
  }

  return (
    <div className={classNames}>
      {displayOverlay && <div className={styles.overlay} style={overlayColor}></div>}
      <div className={cn(styles.content, contentStyle)}>
        <div className={styles.header}>
          <div className={styles.headerRow}>
            {centerTitle ? (
              <>
                <div className={styles.column}>{leftAccessory}</div>
                <div className={styles.column}>{title}</div>
                <div className={styles.column}>
                  <div className={styles.clearContainer}>
                    {isShowClear && (
                      <span className={styles.clear} onClick={clearCart}>
                        Clear
                      </span>
                    )}
                    {showCloseIcon && <CloseIcon className={styles.closeIcon} onClick={onClose} />}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  {leftAccessory}
                  <span className={leftAccessory ? styles.title : null}>{title}</span>
                </div>
                <ButtonBase disableRipple={isE700Device()} component="div" className={styles.closeIconContainer}>
                  {showCloseIcon && <CloseIcon className={styles.closeIcon} onClickCapture={onClose} />}
                </ButtonBase>
              </>
            )}
          </div>
          {subTitleElement}
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  )
}

SidebarModal.defaultProps = {
  show: false,
  title: '',
  subTitle: '',
  leftAccessory: null,
  onClose: () => {},
  contentStyle: undefined,
  children: undefined,
}

SidebarModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  leftAccessory: PropTypes.node,
  onClose: PropTypes.func,
  contentStyle: PropTypes.object,
  children: PropTypes.node,
}

export default SidebarModal
